var MultiBuy = function () {
    // Modern Layout
    var config, dialogWidth, dialogHeight, productHandle, productHandleArray;
    (this.getConfig = function () {
        jQuery
            .ajax({
                url: "https://multibuy.anncode.com/multibuy/api/services/Getconfig",
            })
            .done(function (data) {
                config = data;
                //config.isquantityDisabled=true;
                if (config.isAppEnabled) {
                    config.loaderImageUrl_ = "https://cdn.shopify.com/s/files/1/2978/3294/files/Reload-1s-28px_1.gif?12358665542691632709";
                    jQuery("body").append('<div id="snackbar"></div>');
                    if (config.cartIconDisplay) {
                        jQuery.getJSON("/cart.js", function (cart) {
                            var cartItemCount = cart.item_count;
                            var cartTotal = cart.total_price / 100;
                            cartTotal = shopCurrency + " " + cartTotal.toFixed(2);
                            jQuery("body").append(
                                '<div id="wd-stickyCart"><p id="wd-stick-qty">' +
                                    cartItemCount +
                                    '</p><a href="/cart"><img src="https://cdn.shopify.com/s/files/1/0078/8447/2438/files/if_shopping-cart_216477.png?5083635798551586860"></a><p id="wd-stick-total">' +
                                    cartTotal +
                                    "</p></div>"
                            );
                        });
                    }

                    if (Shopify.theme.theme_store_id == "796") {
                        //                   console.log("run")
                        jQuery('a[href*="/products/"]')
                            .not(".ls-link")
                            .parent()
                            .parent()
                            .find("img[src*='/products/'], img[srcset*='/products/'],img[src*='no-image'], img[data-src*='/products/']")
                            .each(function (index) {
                                jQuery(this).addClass("wd-main-img");
                                dialogWidth = jQuery(this).width();
                                dialogHeight = jQuery(this).height();
                                f = jQuery(this).parent().parent().parent().parent().find("a").attr("href").split("/");
                                productHandle = f[f.length - 1].split("?")[0];
                                jQuery(this)
                                    .parent()
                                    .parent()
                                    .parent()
                                    .parent()
                                    .find("a")
                                    .parent()
                                    .after(
                                        '<div class="wd-cart" style=""><button type="button"  class="btn-main ' +
                                            config.iconPosition +
                                            '" onclick=getProductInformation("' +
                                            productHandle +
                                            '",this,' +
                                            index +
                                            ',"variant") product-handle="' +
                                            productHandle +
                                            '"><i class="material-icons">shopping_cart</i></button></div>'
                                    );
                                jQuery(this).parent().parent().parent().parent().find("a").parent().parent().css("position", "relative");
                                var htmlToAppend = getHtml(index, productHandle);
                                jQuery(this).parent().parent().parent().parent().find("a").parent().parent().find(".wd-cart").append(htmlToAppend);
                            });
                    } 

                    else if (Shopify.theme.theme_store_id == "1567"  ) {
                        /*Refresh theme*/
                        jQuery('a[href*="/products/"]')
                            .not(".ls-link")
                            .parent()
                            .parent()
                            .parent()
                            .parent()
                            .find("img[src*='/products/'], img[srcset*='/products/'],img[src*='no-image'], img[data-src*='/products/']")
                            .each(function (index) {
                                jQuery(this).addClass("wd-main-img");
                                dialogWidth = jQuery(this).width();
                                dialogHeight = jQuery(this).height();
                                f = jQuery(this).parent().parent().parent().parent().parent().parent().parent().find("a").attr("href").split("/");
                                productHandle = f[f.length - 1].split("?")[0];
                                if (jQuery(this).parent().parent().parent().parent().parent().parent().find(".wd-cart").length == 0) {
                                    jQuery(this)
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .find("a")
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .after(
                                            '<div class="wd-cart" style=""><button type="button"  class="btn-main ' +
                                                config.iconPosition +
                                                '" onclick=getProductInformation("' +
                                                productHandle +
                                                '",this,' +
                                                index +
                                                ',"variant") product-handle="' +
                                                productHandle +
                                                '"><i class="material-icons">shopping_cart</i></button></div>'
                                        );
                                    jQuery(this).parent().parent().parent().parent().parent().find("a").parent().parent().parent().parent().parent().css("position", "relative");
                                    var htmlToAppend = getHtml(index, productHandle);
                                    jQuery(this).parent().parent().parent().parent().parent().find("a").parent().parent().parent().parent().parent().find(".wd-cart").append(htmlToAppend);
                                }
                            });
                    } else if (Shopify.theme.theme_store_id == "1500" || Shopify.theme.theme_store_id == "887") {
                        /*ride*/    /*Dawn theme*/
                        jQuery('a[href*="/products/"]')
                            .not(".ls-link")
                            .parent()
                            .parent()
                            .parent()
                            .parent()
                            .find("img[src*='/products/'], img[srcset*='/products/'],img[src*='no-image'], img[data-src*='/products/']")
                            .each(function (index) {
                                jQuery(this).addClass("wd-main-img");
                                dialogWidth = jQuery(this).width();
                                dialogHeight = jQuery(this).height();
                                f = jQuery(this).parent().parent().parent().parent().parent().parent().parent().find("a").attr("href").split("/");
                                productHandle = f[f.length - 1].split("?")[0];
                                if (jQuery(this).parent().parent().parent().parent().parent().parent().find(".wd-cart").length == 0) {
                                    jQuery(this)
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .find("a")
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .not()
                                        .find(".card__inner")
                                        .after(
                                            '<div class="wd-cart" style=""><button type="button"  class="btn-main ' +
                                                config.iconPosition +
                                                '" onclick=getProductInformation("' +
                                                productHandle +
                                                '",this,' +
                                                index +
                                                ',"variant") product-handle="' +
                                                productHandle +
                                                '"><i class="material-icons">shopping_cart</i></button></div>'
                                        );
                                    jQuery(this).parent().parent().parent().parent().parent().find("a").parent().parent().parent().parent().parent().css("position", "relative");
                                    var htmlToAppend = getHtml(index, productHandle);
                                    jQuery(this).parent().parent().parent().parent().parent().find("a").parent().parent().parent().parent().parent().find(".wd-cart").append(htmlToAppend);
                                }
                            });
                    } else if (Shopify.theme.theme_store_id == "1434" ) {
                        /*Taste*/
                        jQuery('a[href*="/products/"]')
                            .not(".ls-link")
                            .parent()
                            .parent()
                            .parent()
                            .parent()
                            .find("img[src*='/products/'], img[srcset*='/products/'],img[src*='no-image'], img[data-src*='/products/']")
                            .each(function (index) {
                                jQuery(this).addClass("wd-main-img");
                                dialogWidth = jQuery(this).width();
                                dialogHeight = jQuery(this).height();
                                f = jQuery(this).parent().parent().parent().parent().parent().parent().parent().find("a").attr("href").split("/");
                                productHandle = f[f.length - 1].split("?")[0];
                                if (jQuery(this).parent().parent().parent().parent().parent().parent().find(".wd-cart").length == 0) {
                                    jQuery(this)
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .find("a")
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .not()
                                        .find(".card__inner")
                                        .after(
                                            '<div class="wd-cart" style=""><button type="button"  class="btn-main ' +
                                                config.iconPosition +
                                                '" onclick=getProductInformation("' +
                                                productHandle +
                                                '",this,' +
                                                index +
                                                ',"variant") product-handle="' +
                                                productHandle +
                                                '"><i class="material-icons">shopping_cart</i></button></div>'
                                        );
                                    jQuery(this).parent().parent().parent().parent().parent().find("a").parent().parent().parent().parent().parent().css("position", "relative");
                                    var htmlToAppend = getHtml(index, productHandle);
                                    jQuery(this).parent().parent().parent().parent().parent().find("a").parent().parent().parent().parent().parent().find(".wd-cart").append(htmlToAppend);
                                }
                            });
                    } else if (Shopify.theme.theme_store_id == "1431") {
                        /*Studio*/
                        jQuery('a[href*="/products/"]')
                            .not(".ls-link")
                            .parent()
                            .parent()
                            .parent()
                            .parent()
                            .find("img[src*='/products/'], img[srcset*='/products/'],img[src*='no-image'], img[data-src*='/products/']")
                            .each(function (index) {
                                jQuery(this).addClass("wd-main-img");
                                dialogWidth = jQuery(this).width();
                                dialogHeight = jQuery(this).height();
                                f = jQuery(this).parent().parent().parent().parent().parent().parent().parent().find("a").attr("href").split("/");
                                productHandle = f[f.length - 1].split("?")[0];
                                if (jQuery(this).parent().parent().parent().parent().parent().parent().find(".wd-cart").length == 0) {
                                    jQuery(this)
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .find("a")
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .not()
                                        .find(".card__inner")
                                        .after(
                                            '<div class="wd-cart" style=""><button type="button"  class="btn-main ' +
                                                config.iconPosition +
                                                '" onclick=getProductInformation("' +
                                                productHandle +
                                                '",this,' +
                                                index +
                                                ',"variant") product-handle="' +
                                                productHandle +
                                                '"><i class="material-icons">shopping_cart</i></button></div>'
                                        );
                                    jQuery(this).parent().parent().parent().parent().parent().find("a").parent().parent().parent().parent().parent().css("position", "relative");
                                    var htmlToAppend = getHtml(index, productHandle);
                                    jQuery(this).parent().parent().parent().parent().parent().find("a").parent().parent().parent().parent().parent().find(".wd-cart").append(htmlToAppend);
                                }
                            });
                    } else if (Shopify.theme.theme_store_id == "1368") {
                        /*Craft*/
                        jQuery('a[href*="/products/"]')
                            .not(".ls-link")
                            .parent()
                            .parent()
                            .parent()
                            .parent()
                            .find("img[src*='/products/'], img[srcset*='/products/'],img[src*='no-image'], img[data-src*='/products/']")
                            .each(function (index) {
                                jQuery(this).addClass("wd-main-img");
                                dialogWidth = jQuery(this).width();
                                dialogHeight = jQuery(this).height();
                                f = jQuery(this).parent().parent().parent().parent().parent().parent().parent().find("a").attr("href").split("/");
                                productHandle = f[f.length - 1].split("?")[0];
                                if (jQuery(this).parent().parent().parent().parent().parent().parent().find(".wd-cart").length == 0) {
                                    jQuery(this)
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .find("a")
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .not()
                                        .find(".card__inner")
                                        .after(
                                            '<div class="wd-cart" style=""><button type="button"  class="btn-main ' +
                                                config.iconPosition +
                                                '" onclick=getProductInformation("' +
                                                productHandle +
                                                '",this,' +
                                                index +
                                                ',"variant") product-handle="' +
                                                productHandle +
                                                '"><i class="material-icons">shopping_cart</i></button></div>'
                                        );
                                    jQuery(this).parent().parent().parent().parent().parent().find("a").parent().parent().parent().parent().parent().css("position", "relative");
                                    var htmlToAppend = getHtml(index, productHandle);
                                    jQuery(this).parent().parent().parent().parent().parent().find("a").parent().parent().parent().parent().parent().find(".wd-cart").append(htmlToAppend);
                                }
                            });
                    } else if (Shopify.theme.theme_store_id == "1363") {
                        /*Crave*/
                        jQuery('a[href*="/products/"]')
                            .not(".ls-link")
                            .parent()
                            .parent()
                            .parent()
                            .parent()
                            .find("img[src*='/products/'], img[srcset*='/products/'],img[src*='no-image'], img[data-src*='/products/']")
                            .each(function (index) {
                                jQuery(this).addClass("wd-main-img");
                                dialogWidth = jQuery(this).width();
                                dialogHeight = jQuery(this).height();
                                f = jQuery(this).parent().parent().parent().parent().parent().parent().parent().find("a").attr("href").split("/");
                                productHandle = f[f.length - 1].split("?")[0];
                                if (jQuery(this).parent().parent().parent().parent().parent().parent().find(".wd-cart").length == 0) {
                                    jQuery(this)
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .find("a")
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .parent()
                                        .not()
                                        .find(".card__inner")
                                        .after(
                                            '<div class="wd-cart" style=""><button type="button"  class="btn-main ' +
                                                config.iconPosition +
                                                '" onclick=getProductInformation("' +
                                                productHandle +
                                                '",this,' +
                                                index +
                                                ',"variant") product-handle="' +
                                                productHandle +
                                                '"><i class="material-icons">shopping_cart</i></button></div>'
                                        );
                                    jQuery(this).parent().parent().parent().parent().parent().find("a").parent().parent().parent().parent().parent().css("position", "relative");
                                    var htmlToAppend = getHtml(index, productHandle);
                                    jQuery(this).parent().parent().parent().parent().parent().find("a").parent().parent().parent().parent().parent().find(".wd-cart").append(htmlToAppend);
                                }
                            });
                    } else if (Shopify.theme.theme_store_id == "1499") {
                        /*color */
                        jQuery('a[href*="/products/"]')
                            .not(".ls-link")
                            .parent()
                            .parent()
                            .parent()
                            .parent()
                            .find("img[src*='/products/'], img[srcset*='/products/'],img[src*='no-image'], img[data-src*='/products/']")
                            .each(function (index) {
                                jQuery(this).addClass("wd-main-img");
                                dialogWidth = jQuery(this).width();
                                dialogHeight = jQuery(this).height();
                                f = jQuery(this).parent().parent().parent().parent().parent().find("a").attr("href").split("/");
                                productHandle = f[f.length - 1].split("?")[0];
                                jQuery(this)
                                    .parent()
                                    .parent()
                                    .parent()
                                    .parent()
                                    .parent()
                                    .find("a")
                                    .parent()
                                    .parent()
                                    .parent()
                                    .parent()
                                    .parent()
                                    .after(
                                        '<div class="wd-cart" style=""><button type="button"  class="btn-main ' +
                                            config.iconPosition +
                                            '" onclick=getProductInformation("' +
                                            productHandle +
                                            '",this,' +
                                            index +
                                            ',"variant") product-handle="' +
                                            productHandle +
                                            '"><i class="material-icons">shopping_cart</i></button></div>'
                                    );
                                jQuery(this).parent().parent().parent().parent().parent().find("a").parent().parent().parent().parent().parent().css("position", "relative");
                                var htmlToAppend = getHtml(index, productHandle);
                                jQuery(this).parent().parent().parent().parent().parent().find("a").parent().parent().parent().parent().parent().find(".wd-cart").append(htmlToAppend);
                            });
                    } else if (Shopify.theme.theme_store_id == "730") {
                        /* theme*/
                        jQuery('a[href*="/products/"]')
                            .not(".ls-link")
                            .parent()
                            .parent()
                            .parent()
                            .parent()
                            .find("img[src*='/products/'], img[srcset*='/products/'],img[src*='no-image'], img[data-src*='/products/']")
                            .each(function (index) {
                                jQuery(this).addClass("wd-main-img");
                                dialogWidth = jQuery(this).width();
                                dialogHeight = jQuery(this).height();
                                f = jQuery(this).parent().parent().parent().parent().parent().find("a").attr("href").split("/");
                                productHandle = f[f.length - 1].split("?")[0];
                                jQuery(this)
                                    .parent()
                                    .parent()
                                    .parent()
                                    .parent()
                                    .parent()
                                    .find("a")
                                    .parent()
                                    .parent()
                                    .parent()
                                    .parent()
                                    .after(
                                        '<div class="wd-cart" style=""><button type="button"  class="btn-main ' +
                                            config.iconPosition +
                                            '" onclick=getProductInformation("' +
                                            productHandle +
                                            '",this,' +
                                            index +
                                            ',"variant") product-handle="' +
                                            productHandle +
                                            '"><i class="material-icons">shopping_cart</i></button></div>'
                                    );
                                jQuery(this).parent().parent().parent().parent().parent().find("a").parent().parent().parent().parent().parent().css("position", "relative");
                                var htmlToAppend = getHtml(index, productHandle);
                                jQuery(this).parent().parent().parent().parent().parent().find("a").parent().parent().parent().parent().parent().find(".wd-cart").append(htmlToAppend);
                            });
                    } 
                    else if (Shopify.theme.theme_store_id == "2455"){
                        jQuery('a[href*="/products/"]').not(".ls-link").find(".product-image").each(function (index) {
                            jQuery(this).addClass('wd-main-img');
                            dialogWidth = jQuery(this).width();
                            dialogHeight = jQuery(this).height();
                            f = jQuery(this).closest("a").attr("href").split("/");
                            productHandle = f[f.length - 1].split("?")[0];
                            jQuery(this).closest("a").after('<div class="wd-cart" style=""><button type="button"  class="btn-main ' + config.iconPosition + '" onclick=getProductInformation("' + productHandle + '",this,' + index + ',"variant") product-handle="' + productHandle + '"><i class="material-icons">shopping_cart</i></button></div>');
                            jQuery(this).closest("a").parent().css('position', 'relative')
                            var htmlToAppend = getHtml(index, productHandle);
                            jQuery(this).closest("a").parent().find('.wd-cart').append(htmlToAppend)
                        });
                    }
                    else {
                        jQuery('a[href*="/products/"]')
                            .not(".ls-link")
                            .find("img[src*='/products/'], img[srcset*='/products/'],img[src*='no-image'], img[data-src*='/products/']")
                            .each(function (index) {
                                jQuery(this).addClass("wd-main-img");
                                dialogWidth = jQuery(this).width();
                                dialogHeight = jQuery(this).height();
                                f = jQuery(this).closest("a").attr("href").split("/");
                                productHandle = f[f.length - 1].split("?")[0];
                                jQuery(this)
                                    .closest("a")
                                    .after(
                                        '<div class="wd-cart" style=""><button type="button"  class="btn-main ' +
                                            config.iconPosition +
                                            '" onclick=getProductInformation("' +
                                            productHandle +
                                            '",this,' +
                                            index +
                                            ',"variant") product-handle="' +
                                            productHandle +
                                            '"><i class="material-icons">shopping_cart</i></button></div>'
                                    );
                                jQuery(this).closest("a").parent().css("position", "relative");
                                var htmlToAppend = getHtml(index, productHandle);
                                jQuery(this).closest("a").parent().find(".wd-cart").append(htmlToAppend);
                            });
                    }
                }
            });
    }),
        (getHtml = function (index, productHandles) {
            var htmlToAppend = "";
            htmlToAppend += "<div>";
            //Add to cart checkbox
            // htmlToAppend += "<div  id='desc_" + productHandle + "' class='wd-descs'  onclick=getProductInformation('" + productHandle + "',this," + index + ",'description') >Desc</div>";
            // htmlToAppend += "<input type='checkbox' id='chk_" + productHandle + "' class='wd-quick-view'  onclick=getProductInformation('" + productHandle + "',this," + index + ",'variant') />";
            //Add to cart text label
            // htmlToAppend += "<label for='chk_" + productHandle + "' class='wd-ma-addtocart-chkbx'>" + config.checkBoxText + "</label>";
            //Loader Image
            htmlToAppend += "<div class='variant-loader loader_" + config.iconPosition + "'><img src='" + config.loaderImageUrl_ + "'  height=24 width=24/></div>";
            //selected Variant detail
            htmlToAppend += "<span class='wd-ma-selected-variants-info' ></span>";

            //Variant Box Container
            htmlToAppend += "<div class='wd-ma-variants-outer' style='width:" + dialogWidth + "px; height:" + dialogHeight + "px; ' >";
            //selected variant id (hidden)
            if (config.iconPosition == "topRight") {
                if (Shopify.theme.theme_store_id == "1500") {
                    htmlToAppend += "<span class='wd-close close-left' onclick=javascript:this.parentNode.style.display='none' style='color:black'>X</span>";
                } else {
                    htmlToAppend += "<span class='wd-close close-left' onclick=javascript:this.parentNode.style.display='none'>X</span>";
                }
                htmlToAppend += "<span class='wd-close close-left' onclick=javascript:this.parentNode.style.display='none'>X</span>";
            } else if (config.iconPosition == "topLeft") {
                htmlToAppend += "<span class='wd-close close-right' onclick=javascript:this.parentNode.style.display='none'>X</span>";
            }

            htmlToAppend += "<div style='width:90%;left:5%;position:absolute;top:50%;top:50%;transform: translateY(-50%);'>";
            htmlToAppend += "<span class='selected-variant-id' style='display:none;'></span>";
            //Variants options
            htmlToAppend += "<div class='variants'></div>";
            htmlToAppend += "<div>";
            if (config.isLabelEnabled && config.isquantityEnabled) {
                htmlToAppend += "<label>Quantity</label>";
                htmlToAppend += "<span class='wd-instock'></span>";
            }
            if (config.isquantityEnabled) {
                htmlToAppend += "<select  class='qty-box'>";

                for (i = 1; i <= config.maxQuantity; i = i + 1) {
                    htmlToAppend += "<option value=" + i + ">" + i + "</option>";
                }
                htmlToAppend += "</select>";
            }
            htmlToAppend += "</div>";

            htmlToAppend += "<span onclick=javascript:addtoCart(this); class='wd-ma-variant-ok-btn'>" + config.okButtonText + "</span>";
            htmlToAppend += "</div>";
            htmlToAppend += "</div>";
            htmlToAppend += "</div>";
            return htmlToAppend;
        }),
        (addtoCart = function (elem) {
            jQuery("#snackbar").html("");
            var Qty = jQuery(elem).parent().find(".qty-box").val();
            //if(config.cartAddType=='each'){
            var wdVariantId = jQuery(elem).parent().find(".selected-variant-id").text();
            //alert(wdVariantId)
            Shopify.addItem(wdVariantId, Qty, null, 0, 0, elem);
            //}else
            //{
            //}
        }),
        (getProductInformation = function (handle, elem, index, type) {
            if (config.closeOtherVariantbox) {
                // jQuery('.wd-ma-variants-outer').hide();
            }
            var selectedVariantId;
            var selectedVariantName;
            var variantQuantityAvailable;
            // alert( jQuery(elem).closest("a").html())
            var variantHtml = jQuery(elem).parent().find(".variants").html();
            var isVar = false;
            var variantBoxDisplay = false;
            //alert(variantHtml)
            //if variant information is not fetched and filled
            if (variantHtml == "") {
                //show loader if enabled in settings
                if (config.variantLoader) {
                    jQuery(elem).parent().find(".variant-loader").show();
                }
                jQuery(elem).attr("disabled", true);
                var requestUrl = "/products/" + handle + ".js";
                $.getJSON(requestUrl, function (ProductData) {
                    jQuery(elem)
                        .parent()
                        .append("<script> var prd" + index + "=" + JSON.stringify(ProductData) + "</script>");

                    // var pDesc = ProductData.description;
                    //jQuery(elem).parent().append('<div><div class="wd-desc" style="">' + pDesc + '</div></div>');

                    var optionLength = ProductData.options.length;
                    for (i = 0; i < optionLength; i++) {
                        if (ProductData.options[i].name != "Title") {
                            var select = document.createElement("select");
                            select.id = "opt-" + ProductData.options[i].name;
                            select.setAttribute("onchange", "changeVariant(1," + index + ",eval('prd' + " + index + "))");
                            select.setAttribute("class", "variant-options");
                            for (j = 0; j < ProductData.options[i].values.length; j++) {
                                var optionVal = ProductData.options[i].values[j];
                                var option = document.createElement("option");
                                option.textContent = optionVal;
                                option.value = optionVal;
                                select.appendChild(option);
                            }
                            variantBoxDisplay = true;
                            if (config.isLabelEnabled) {
                                var variantLabel = ProductData.options[i].name;
                                jQuery(elem)
                                    .parent()
                                    .find(".variants")
                                    .append("<label>" + variantLabel + "</label>");
                            }
                            jQuery(elem).parent().find(".variants").append(select);
                            //jQuery(elem).parent().find('.wd-ma-variants-outer').show();
                            if (jQuery(elem).parent().parent().find(".wd-ma-variants-outer").css("display") == "none") {
                                jQuery(elem)
                                    .parent()
                                    .parent()
                                    .find(".wd-ma-variants-outer")
                                    .animate(
                                        {
                                            height: "toggle",
                                        },
                                        290,
                                        function () {
                                            //jQuery(elem).parent().find('.wd-desc').hide();
                                        }
                                    );
                            }

                            selectedVariantId = ProductData.variants[0].id;
                            selectedVariantName = ProductData.variants[0].title;
                            variantQuantityAvailable = ProductData.variants[0].inventory_quantity;
                            jQuery(elem).parent().find(".wd-ma-selected-variants-info").html(selectedVariantName);
                            jQuery(elem).parent().find(".selected-variant-id").html(selectedVariantId);
                        } else {
                            variantBoxDisplay = false;
                            //alert("2")
                            // jQuery(elem).parent().find('.wd-ma-variants-outer').show();
                            if (config.isquantityEnabled) {
                                if (jQuery(elem).parent().parent().find(".wd-ma-variants-outer").css("display") == "none") {
                                    jQuery(elem)
                                        .parent()
                                        .parent()
                                        .find(".wd-ma-variants-outer")
                                        .animate(
                                            {
                                                height: "toggle",
                                            },
                                            290,
                                            function () {
                                                // jQuery(elem).parent().find('.wd-desc').hide();
                                            }
                                        );
                                }
                                selectedVariantId = ProductData.variants[0].id;
                                selectedVariantName = ProductData.variants[0].title;
                                variantQuantityAvailable = ProductData.variants[0].inventory_quantity;
                                jQuery(elem).parent().find(".variants").append(selectedVariantName);
                                jQuery(elem).parent().find(".variants").hide();
                                if (selectedVariantName != "Default Title") {
                                    jQuery(elem).parent().find(".wd-ma-selected-variants-info").html(selectedVariantName);
                                }
                                jQuery(elem).parent().find(".selected-variant-id").html(selectedVariantId);
                            } else {
                                selectedVariantId = ProductData.variants[0].id;
                                jQuery(elem).parent().find(".selected-variant-id").html(selectedVariantId);
                                addtoCart(jQuery(elem).parent().find("span.wd-ma-variant-ok-btn"));
                            }
                        }
                        jQuery(elem).parent().find(".variant-loader").hide();
                        jQuery(elem).removeAttr("disabled");
                    }
                    changeVariant = function (occur, index, obj) {
                        elem = jQuery(".wd-cart:eq(" + index + ")");
                        setTimeout(function () {
                            var optionLength = obj.options.length;
                            var selectedOptions = [];
                            for (i = 0; i < optionLength; i++) {
                                selectedOptions[i] = elem
                                    .parent()
                                    .find(".variant-options:eq(" + i + ")")
                                    .val();
                            }
                            var difference = [];
                            var variantPrice;
                            for (j = 0; j < obj.variants.length; j++) {
                                var array2 = obj.variants[j].options;
                                var is_same =
                                    selectedOptions.length == array2.length &&
                                    selectedOptions.every(function (element, index) {
                                        return element === array2[index];
                                    });
                                if (is_same == true) {
                                    variantPrice = obj.variants[j].price / 100;
                                    variantPrice = variantPrice.toFixed(2);
                                    jQuery(".variant-price").text(variantPrice);
                                    selectedVariantId = obj.variants[j].id;
                                    elem.parent().parent().find(".selected-variant-id").html(selectedVariantId);
                                    selectedVariantName = obj.variants[j].title;
                                    variantQuantityAvailable = obj.variants[j].available;
                                    variantQuantity = obj.variants[j].inventory_quantity;
                                    //alert(variantQuantityAvailable)
                                    if (config.instockDisplay && variantQuantity != undefined) {
                                        jQuery(elem)
                                            .parent()
                                            .find(".wd-instock")
                                            .text(variantQuantity + " Instock");
                                    }
                                    if (!variantQuantityAvailable) {
                                        jQuery(elem).parent().find(".wd-ma-variant-ok-btn").text("Out of stock");
                                        jQuery(elem).parent().find(".wd-ma-variant-ok-btn").attr("onclick", "");
                                        //jQuery(elem).parent().find('.wd-ma-selected-variants-info').html('out of stock');
                                    } else {
                                        jQuery(elem).parent().find(".wd-ma-variant-ok-btn").text(config.okButtonText);
                                        jQuery(elem).parent().find(".wd-ma-variant-ok-btn").attr("onclick", "javascript:addtoCart(this)");

                                        jQuery(elem).parent().find(".wd-ma-selected-variants-info").html(selectedVariantName);
                                    }
                                    if (occur == 1 && config.isChangeVariantImage) {
                                        try {
                                            variantImage = obj.variants[j].featured_image.src;
                                            //  alert(variantImage)
                                            //  alert(index);
                                            jQuery(".wd-main-img:eq(" + index + ")").removeAttr("srcset");
                                            jQuery(".wd-main-img:eq(" + index + ")").removeAttr("data-srcset");

                                            jQuery(".wd-main-img:eq(" + index + ")").prop("src", variantImage);
                                        } catch (e) {}
                                    }
                                }
                            }
                        }, 100);
                    };
                    changeVariant(0, index, eval("prd" + index));
                    if (elem.is(":checked")) {
                        if (variantBoxDisplay) {
                            // elem.parent().find('.wd-ma-variants-outer').show();
                            //  alert("3")
                            if (elem.parent().parent().find(".wd-ma-variants-outer").css("display") == "none") {
                                elem.parent()
                                    .parent()
                                    .find(".wd-ma-variants-outer")
                                    .animate(
                                        {
                                            height: "toggle",
                                        },
                                        290,
                                        function () {}
                                    );
                            }
                        }
                        elem.parent().find(".wd-ma-selected-variants-info").css("display", "block");
                    } else {
                        elem.parent().find(".wd-ma-selected-variants-info").css("display", "none");
                    }
                });
            } else {
                //alert("in")
                /* if (jQuery(elem).is(':checked')) {
                     // jQuery(elem).parent().find('.wd-ma-variants-outer').show();
                     //alert("4")
                     if (jQuery(elem).parent().parent().find('.wd-ma-variants-outer').css('display') == 'none') {
                         jQuery(elem).parent().parent().find('.wd-ma-variants-outer').animate({
                             height: 'toggle'
                         }, 290, function() {});
                     }
                     jQuery(elem).parent().parent().find('.wd-ma-selected-variants-info').css('visibility', 'visible');
                 } else {
                   */
                // jQuery(elem).parent().find('.wd-ma-variants-outer').show();
                //jQuery(elem).parent().find('.wd-ma-selected-variants-info').css('visibility', 'hidden');
                // }

                jQuery(elem)
                    .parent()
                    .find(".wd-ma-variants-outer")
                    .animate(
                        {
                            height: "toggle",
                        },
                        290,
                        function () {}
                    );
            }
        });

    function addItems(t, r, e, k, selectedCount) {
        var r = r || 1,
            a = {
                type: "POST",
                url: "/cart/add.js",
                data: "quantity=" + r + "&id=" + t,
                dataType: "json",
                async: false,
                success: function (t) {
                    "function" == typeof e ? e(t) : Shopify.onItemAdded(t, k, selectedCount);
                },
                error: function (t, r) {
                    Shopify.onError(t, r);
                },
            };
        jQuery.ajax(a);
    }

    var cnt_ = 0;
    (Shopify.onItemAdded = function (t, k, selectedCount, elem) {
        if (config.hideWhenAdded) {
            jQuery(elem).parent().parent().hide();
        }
        cnt_++;
        if (config.oneClickCheckout == true) {
            window.location.href = "/checkout";
        } else {
            if (config.redirectToCart == false) {
                posTop = cnt_ * 40 + "px";
                $("#snackbar").append('<div  style="top:100px;"  class="wd-ma-snackbar snackbar  ' + t.id + '" >' + t.title + " was added to your shopping cart.</div>");
                jQuery("." + t.id)
                    .show()
                    .delay(3000)
                    .fadeOut(1000);
                //if (cnt_ == selectedCount) {

                setTimeout(function () {
                    if (Shopify.theme.theme_store_id == "829" || Shopify.theme.theme_store_id == "719") {
                        window.location.reload(true);
                    }
                }, 2000);

                //all items added to cart
                // alert("all added")
                // setTimeout(function() {
                jQuery.getJSON("/cart.js", function (cart) {
                    var cartItemCount_ = cart.item_count;
                    //alert(cartItemCount_)
                    var cartTotal_ = cart.total_price / 100;
                    //alert(cartTotal_)
                    cartTotal_ = shopCurrency + " " + cartTotal_.toFixed(2);
                    jQuery("#wd-stick-qty").html(cartItemCount_);
                    jQuery("#wd-stick-total").html(cartTotal_);
                });
                //}, 100)
                //  }
            } else {
                window.location.href = "/cart";
            }
        }
    }),
        (Shopify.addItem = function (t, r, e, k, selectedCount, elem) {
            var r = r || 1,
                a = {
                    type: "POST",
                    url: "/cart/add.js",
                    data: "quantity=" + r + "&id=" + t,
                    dataType: "json",
                    async: false,
                    success: function (t) {
                        "function" == typeof e ? e(t) : Shopify.onItemAdded(t, k, selectedCount, elem);
                    },
                    error: function (t, r) {
                        Shopify.onError(t, r);
                    },
                };
            jQuery.ajax(a);
        }),
        (Shopify.onError = function (t, r) {
            var e = eval("(" + t.responseText + ")");
            //e.message ? alert(e.message + "(" + e.status + "): " + e.description) : alert("Error : " + Shopify.fullMessagesFromErrors(e).join("; ") + ".")
            e.message ? alert(e.description) : alert("Error : " + Shopify.fullMessagesFromErrors(e).join("; ") + ".");
        }),
        (Shopify.fullMessagesFromErrors = function (t) {
            var r = [];
            return (
                jQuery.each(t, function (t, e) {
                    jQuery.each(e, function (e, a) {
                        r.push(t + " " + a);
                    });
                }),
                r
            );
        });
};

var xx = new MultiBuy();
xx.getConfig();


jQuery(document).on('click','input[type=checkbox], .clear_filter',function(){
  setTimeout(() => {
  var xx = new MultiBuy();
xx.getConfig();
}, 1000);

   
})
